export default {
    emailList: [],
    levelList: [],
    idList: [],
    setUserList: []
}
